import * as e from "react";
import { forwardRef as o } from "react";
const i = o(function(t, r) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M17 18L20 20V4H4V20L7 18",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M12 9C11.1393 9 10.3632 9.36249 9.81611 9.94314L12 11.3991L14.1839 9.94314C13.6368 9.36249 12.8607 9 12 9ZM14.7392 10.7748L12.5 12.2676V14.9585C13.9189 14.7205 15 13.4865 15 12C15 11.5636 14.9068 11.1489 14.7392 10.7748ZM9 12C9 11.5636 9.0932 11.1489 9.26078 10.7748L11.5 12.2676V14.9585C10.0811 14.7205 9 13.4865 9 12ZM7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  i as Futsal
};
